import React, { LegacyRef } from 'react';
import cn from 'clsx';
import { ClockCounterClockwiseIcon, MapPinLineIcon } from '@fronton/icons-react';
import { Layout } from 'fronton-react';
import { COMMON_LANDINGS_IMAGES_CDN_PATH } from 'common/constants/common';
import { ButtonWithGAClickButton, Section, SIGN_SECTION_MOBILE_PANEL_STRUCTURE, SignSectionPanel, Typography } from 'common/components';
import { CABINET_ELEMENT_BLOCK } from '../../cabinet-constants';
import {
  cabinetSignSectionTitle,
  cabinetSignSection,
  cabinetSignSectionPoint,
  cabinetSignSectionPointsWrapper,
  cabinetSignSectionBlockWrapper,
  cabinetSignSectionColumnPoint,
  cabinetSignSectionContainer,
  cabinetSignSectionPointsOnlineWrapper,
  cabinetSignSectionOnlineImage,
  cabinetSignSectionAddContentContainer,
  cabinetSignSectionPointsColumnWrapper,
} from './cabinet-sign-section-styles';

type CabinetSignSectionProps = {
  panelRef: LegacyRef<HTMLDivElement>;
  signHref: string;
};

export const CabinetSignSection: React.FC<CabinetSignSectionProps> = ({
  panelRef,
  signHref,
}) => (
  <Section className={cabinetSignSection}>
    <Layout>
      <div className={cabinetSignSectionContainer}>
        <div className={cabinetSignSectionBlockWrapper}>
          <Typography className={cabinetSignSectionTitle} variant="h2" color="text-invert">
            Создать или завершить проект с&nbsp;персональным менеджером можно онлайн
          </Typography>

          <div className={cabinetSignSectionPointsColumnWrapper}>
            <div className={cabinetSignSectionColumnPoint}>
              <ClockCounterClockwiseIcon size="38px" color="var(--control-accent)" type="duotone" />
              <Typography variant="l" size="body_accent" color="text-invert">
                в&nbsp;любое время
              </Typography>
            </div>
            <div className={cabinetSignSectionColumnPoint}>
              <MapPinLineIcon size="38px" color="var(--control-accent)" type="duotone" />
              <Typography variant="l" size="body_accent" color="text-invert">
                в&nbsp;любом месте
              </Typography>
            </div>
          </div>
        </div>
        <div className={cabinetSignSectionBlockWrapper}>
          <img
            className={cabinetSignSectionOnlineImage}
            src={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/sign-section/online.png/online.png`}
            alt="Создание проекта онлайн"
            width="578"
            height="302"
          />
          <div
            className={cn(cabinetSignSectionPointsWrapper, cabinetSignSectionPointsOnlineWrapper)}>
            <div className={cabinetSignSectionPoint}>
              <ClockCounterClockwiseIcon size="38px" color="var(--control-accent)" type="duotone" />
              <Typography variant="l" size="body_accent" color="text-invert">
                в&nbsp;любое время
              </Typography>
            </div>
            <div className={cabinetSignSectionPoint}>
              <MapPinLineIcon size="38px" color="var(--control-accent)" type="duotone" />
              <Typography variant="l" size="body_accent" color="text-invert">
                в&nbsp;любом месте
              </Typography>
            </div>
          </div>
        </div>
      </div>

      <div className={cabinetSignSectionAddContentContainer}>
        <SignSectionPanel
          elementBlock={CABINET_ELEMENT_BLOCK}
          elementName='Создать или завершить проект с персональным менеджером можно онлайн'
          mobilePanelStructure={{
            ...SIGN_SECTION_MOBILE_PANEL_STRUCTURE,
            content: {
              ...SIGN_SECTION_MOBILE_PANEL_STRUCTURE.content,
              text: 'Запишитесь на\u00A0бесплатное проектирование \u2014 сделаем ваш дом удобным и\u00A0стильным',
            },
            actionBlock: [
              {
                elementBlock: CABINET_ELEMENT_BLOCK,
                href: signHref,
                label: 'Записаться',
                target: '_blank',
                variant: 'accent',
              },
            ],
          }}
          panelButton={
            <ButtonWithGAClickButton
              elementBlock={CABINET_ELEMENT_BLOCK}
              elementName='Создать или завершить проект с персональным менеджером можно онлайн'
              elementText='Записаться на проектирование'
              href={signHref}
              invert
              variant="accent"
              target="_blank"
            >
              Записаться на проектирование
            </ButtonWithGAClickButton>
          }
          panelRef={panelRef}
          text={`Запишитесь на\u00A0бесплатное проектирование \u2014\nсделаем ваш дом удобным и\u00A0стильным`}
        />
      </div>
    </Layout>
  </Section>
);